import 'css-chunksrc/client/pages/projectPage/synthesisPage/weatherReport/styles.scss';export default {
  "weatherReport": "_weatherReport_13l90_1",
  "weather": "_weather_13l90_1",
  "opened": "_opened_13l90_9",
  "toggleButton": "_toggleButton_13l90_13",
  "toggleIcon": "_toggleIcon_13l90_23",
  "main": "_main_13l90_30",
  "loader": "_loader_13l90_41",
  "loaderMain": "_loaderMain_13l90_49",
  "weatherIcon": "_weatherIcon_13l90_54",
  "readOnly": "_readOnly_13l90_63"
};